import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 36 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M29.187.654 16.644 13.197l-1.308-1.309 9.486-9.486L22.421 0l-9.487 9.487L9.168 5.72 6.766 8.122l3.766 3.766-1.308 1.309-6.822-6.822L0 8.776 9.224 18l3.71-3.71 3.71 3.71L31.588 3.056 29.187.654Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render };